const hamburger = document.querySelector('.header__hamburger');
const searchBtn = document.querySelector('.header__button--search');
const searchBar = document.querySelector('.header__search');
const menu = document.querySelector('.header__menu');
const website = document.querySelector('.website');

hamburger.addEventListener('click', function () {
    menu.classList.toggle('active');
    searchBar.classList.remove('active');
    website.classList.toggle('hamburger-active');
    hamburger.classList.toggle('active');
});

searchBtn.addEventListener('click', function () {
    searchBar.classList.toggle('active');
    menu.classList.remove('active');
    hamburger.classList.remove('active');
    website.classList.remove('hamburger-active');
});
